<app-header></app-header>

<main>
    <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
